import React from 'react'
import { Toolbar } from "@material-ui/core"
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { ConfirmProvider } from 'material-ui-confirm'
import User from '../users/User'
import Profiles from '../profiles/Profiles'
import Groups from '../groups/Groups'
import Locations from '../locations/Locations'
import Programs from '../programs/Programs'
import Cardholders from '../cardholders/Cardholders'
import CardholderDetails from '../cardholders/CardholderDetails'
import Promotions from '../promotions/Promotions'
import useStyles from '../../hooks/useStyles'
import Footer from './Footer'
import Reports from '../reports/Reports'
import MiniCMS from '../cms/MiniCMS'

function Main({ mainClassName }) {
    const { path } = useRouteMatch()
    const classes = useStyles()
    return (
        <ConfirmProvider>
            <div className={mainClassName}>
                <Toolbar variant="dense" className={classes.dummyToolBar} />
                {/* pages rendered here */}
                <Switch>
                    <Route path={`${path}user`}><User /></Route>
                    <Route path={`${path}profiles`}><Profiles /></Route>
                    <Route path={`${path}groups`}><Groups /></Route>
                    <Route path={`${path}locations`}><Locations /></Route>
                    <Route path={`${path}programs`}><Programs /></Route>
                    <Route exact path={`${path}cardholders`}><Cardholders /></Route>
                    <Route path={`${path}cardholders/:id`}><CardholderDetails /></Route>
                    <Route path={`${path}promotions`}><Promotions /></Route>
                    <Route path={`${path}reports`}><Reports /></Route>
                    <Route path={`${path}cms`}><MiniCMS /></Route>
                    <Route exact path={path}><Redirect to="/user"/></Route>
                </Switch>
                <Footer variant="light" />
            </div>
        </ConfirmProvider>
    );
}

export default Main;